export default "__VITE_ASSET__CN2dWjE6__"